import { default as Axios } from "axios";
import mapboxgl from "mapbox-gl";
import { MapboxMapingResponse } from "../models/MapboxMapping";

const axios = Axios.create({
  baseURL: "https://api.mapbox.com/matching/v5/mapbox",
});
const profile = "cycling";

export const mapboxMatch = async (coordString: string) => {
  const url = `/${profile}?access_token=${mapboxgl.accessToken}`;
  const requestBody = `coordinates=${coordString}`;

  return await axios
    .post<MapboxMapingResponse>(url, requestBody)
    .then(({ data }) => (data.code === "Ok" ? data.tracepoints : []));
};
